import ds from './DataSourceService'

const baseUrl = '/users'

const getUserProfile = () => {
  return ds.apiClientThinkHome.get(baseUrl + '/profile')
}

const refreshToken = () => {
  return ds.apiClientThinkHome.get(baseUrl + '/refresh-token')
}

const logout = () => {
  return ds.apiClientThinkHome.get(baseUrl + '/logout')
}

const createUser = data => {
  return ds.apiClientThinkHome.post(baseUrl, data)
}

const changeAdminOnProject = data => {
  return ds.apiClientThinkHome.post(
    baseUrl + `/project/${data.projectId}/change-project-admin`,
    data
  )
}

const removeUserFromProject = data => {
  return ds.apiClientThinkHome.post(baseUrl + `/delete-project-user`, data)
}

const signup = data => {
  return ds.apiClientThinkHome.post(baseUrl + '/signup', data)
}

const verifyEmailAddressCode = data => {
  return ds.apiClientThinkHome.post(baseUrl + '/confirm-email-verify', {
    token: data
  })
}

const sendLoginPasswordResetLink = data => {
  return ds.apiClientThinkHome.post(baseUrl + '/password-reset', {
    username: data
  })
}

const sendEmailAddressConfirmationLink = data => {
  return ds.apiClientThinkHome.post(baseUrl + '/confirm-email', {
    username: data
  })
}

const resetUserPassword = data => {
  return ds.apiClientThinkHome.put(baseUrl + '/password-reset', {
    token: data.token,
    password: data.userPassword
  })
}

const setUserPassword = data => {
  return ds.apiClientThinkHome.post(baseUrl + '/password-set', {
    token: data.token,
    password: data.userPassword
  })
}

const updateUserData = data => {
  return ds.apiClientThinkHome.patch(baseUrl, {
    firstName: data.firstName,
    lastName: data.lastName
  })
}

const updateUserPassword = data => {
  return ds.apiClientThinkHome.put(baseUrl + '/password-update', {
    password: data
  })
}

const uploadUserFile = (projectId, files) => {
  return ds.apiClientThinkHome.post(
    baseUrl + '/project/' + projectId + '/add-user-media',
    files,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
}

const getProjectUserMedia = projectId => {
  return ds.apiClientThinkHome.get(
    baseUrl + '/project/' + projectId + '/get-user-media'
  )
}

const getUserRole = () => {
  return ds.apiClientThinkHome.get(baseUrl + '/get-user-role')
}

const getUserRoles = () => {
  return ds.apiClientThinkHome.get(baseUrl + '/get-user-roles')
}

const getAllUserRoles = () => {
  return ds.apiClientThinkHome.get(baseUrl + '/get-all-user-roles')
}

const isAllowedOnResource = (resourceName, permission, projectId) => {
  let prId = projectId !== undefined ? '&projectId=' + projectId : ''
  let url =
    baseUrl +
    '/is-allowed?resource=' +
    resourceName +
    '&permission=' +
    permission +
    prId
  return ds.apiClientThinkHome.get(url)
}

export default {
  getUserProfile,
  createUser,
  refreshToken,
  logout,
  changeAdminOnProject,
  verifyEmailAddressCode,
  sendLoginPasswordResetLink,
  sendEmailAddressConfirmationLink,
  resetUserPassword,
  setUserPassword,
  updateUserData,
  updateUserPassword,
  uploadUserFile,
  getProjectUserMedia,
  getUserRole,
  isAllowedOnResource,
  signup,
  getUserRoles,
  getAllUserRoles,
  removeUserFromProject
}
